import React, { memo } from "react";
import classNames from "classnames";
import { RiCalendarLine, RiDiscussLine } from "@remixicon/react";
import ReactTimeago from "react-timeago";
import { CardElement } from "../../components/agent-v3/board/card/Card";
import RequestType from "../../components/agent-v3/labels/request-type/RequestType";
import Styles from "./Tickets.module.scss";
import Priority from "../../components/agent-v3/labels/priority/Priority";
import Source from "../../components/agent-v3/labels/source/Source";
import { Ticket } from "./TicketsV3";

function TicketRow({ ticket, openTicket }: { ticket: Ticket, openTicket: (ticketId: number | string) => void }) {
    const createdDate = new Date(ticket.createdDate);
    const ticketId = ticket.ticketNumber ?? ticket.id;

    return (
        <tr
            className={classNames(Styles.card, Styles["card-compact"])}
            onClick={() => openTicket(ticketId)}
        >
            <CardElement nodeType="td" className="card-row-ticket-number">
                #
                {ticket.ticketNumber}
            </CardElement>
            <CardElement nodeType="td" className="card-row-subject" title="Ticket subject">
                {ticket.subject}
            </CardElement>

            <CardElement nodeType="td" className="card-row-priority">
                <Priority ticketPriority={ticket.priority} />
            </CardElement>

            <CardElement nodeType="td" className="card-row-request-type">
                <RequestType requestType={ticket.form?.name} />
            </CardElement>

            <CardElement nodeType="td" className="card-created-date" title={`Created Date: ${createdDate.toLocaleString()}`}>
                <RiCalendarLine className="card-meta-icon" />
                {" "}
                {createdDate.toLocaleDateString().replace(
                    createdDate.getFullYear().toString(),
                    (createdDate.getFullYear() % 1000).toString(),
                )}
            </CardElement>

            <CardElement nodeType="td" className="card-row-source" title={`Conversation Source: ${ticket.source?.text}`}>
                <Source type={ticket.source?.type} text={ticket.source?.text} />
            </CardElement>

            <CardElement nodeType="td" className="card-message-count" title="Message Count">
                <RiDiscussLine className="card-meta-icon" />
                {" "}
                {ticket.messageCount ?? 0}
            </CardElement>

            <CardElement nodeType="td" className="card-row-created-date">
                <ReactTimeago
                    date={ticket.lastResponseDate}
                    title="Modified"
                />
            </CardElement>

        </tr>
    );
}

export default memo(TicketRow);
